import { defineComponent } from 'vue';
import { mapState } from 'vuex';

import { IPermissions } from '../interfaces/IPermissions';

export const DefaultPermissionsMixin = defineComponent({
  computed: {
    ...mapState({
      defaultPermissions: (state: any): IPermissions => state.accountSettings.permissions
    })
  }
});
